/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import api from '../../services/axios'
import { toast } from 'react-toastify'
import Select from 'react-select'
import { ThreeDot } from 'react-loading-indicators'
import { SkeletonRow } from '../../components/Skeletron'
import {
  DatabaseContainer,
  DatabaseHeader,
  TabBar,
  TabItem,
  FiltersRow,
  SearchBox,
  FiltersGroup,
  StyledSelect,
  TableWrapper,
  ModernTable,
  StatusBadge,
  ActionButton,
  Paginator,
  PageButton,
} from './styles'
import {
  ModernModalBackdrop,
  ModernVerticalModal,
  ModalFieldGroup,
  ModalLabel,
  ModalInput,
  ModalSelect,
  SubmitButton,
  Modal,
} from '../../styles/Modal'
import { FiSearch, FiPlus, FiEdit2, FiCheck, FiRefreshCw, FiAlertTriangle } from 'react-icons/fi'
import { IoCloseCircleSharp } from 'react-icons/io5'
import { useAuth } from '../../context/AuthContext'
import { carregarDistribuidores } from '../../services/dists'

const customSelectStyles = {
  control: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: 'rgba(0, 24, 66, 0.8)',
    borderColor: state.isFocused ? '#3b82f6' : 'rgba(255, 255, 255, 0.1)',
    borderRadius: '12px',
    minHeight: '44px',
    borderWidth: '1px',
    boxShadow: state.isFocused ? '0 0 0 2px rgba(59, 130, 246, 0.2)' : 'none',
    '&:hover': {
      borderColor: state.isFocused ? '#3b82f6' : 'rgba(255, 255, 255, 0.2)',
    },
  }),
  singleValue: (provided: any) => ({
    ...provided,
    color: '#ffffff',
    fontFamily: "'Montserrat', sans-serif",
    fontSize: '14px',
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: '#64748b',
    fontFamily: "'Montserrat', sans-serif",
    fontSize: '14px',
  }),
  input: (provided: any) => ({
    ...provided,
    color: '#ffffff',
    fontFamily: "'Montserrat', sans-serif",
  }),
  menu: (provided: any) => ({
    ...provided,
    backgroundColor: '#001842',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '12px',
    overflow: 'hidden',
    zIndex: 9999,
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#2563eb'
      : state.isFocused
      ? 'rgba(255, 255, 255, 0.05)'
      : 'transparent',
    color: '#ffffff',
    fontFamily: "'Montserrat', sans-serif",
    fontSize: '14px',
    cursor: 'pointer',
    '&:active': {
      backgroundColor: '#1d4ed8',
    },
  }),
}

function formatDateTimePtBr(dateLike: string | number | Date | null | undefined) {
  if (!dateLike) return '—'
  const dt = new Date(dateLike)
  if (isNaN(dt.getTime())) return '—'
  return dt.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export default function PendingFilesView() {
  const { user } = useAuth()
  const [isAdmin, setIsAdmin] = useState(false)
  const [activeTab, setActiveTab] = useState<'valid_products' | 'invalid_products'>('valid_products')
  const [distribuidores, setDistribuidores] = useState<any[]>([])

  // Listagem de Produtos Válidos (Internos)
  const [validProducts, setValidProducts] = useState<any[]>([])
  const [validLoading, setValidLoading] = useState(false)
  const [validPage, setValidPage] = useState(1)
  const [validTotalPages, setValidTotalPages] = useState(1)
  const [validTotal, setValidTotal] = useState(0)
  const [validSearch, setValidSearch] = useState('')
  const [validStatusFilter, setValidStatusFilter] = useState('')

  // Form de Produto Válido (Novo / Edição)
  const [openValidForm, setOpenValidForm] = useState(false)
  const [editingValidProduct, setEditingValidProduct] = useState<any | null>(null)
  const [validSku, setValidSku] = useState('')
  const [validDescricao, setValidDescricao] = useState('')
  const [validFamilia, setValidFamilia] = useState('')
  const [validCategoria, setValidCategoria] = useState('')
  const [validMarca, setValidMarca] = useState('')
  const [validEan13, setValidEan13] = useState('')
  const [validDun14, setValidDun14] = useState('')
  const [validCategoriaPex, setValidCategoriaPex] = useState('')
  const [validStatus, setValidStatus] = useState('Ativo')
  const [validUnCx, setValidUnCx] = useState<number | ''>('')
  const [validCodCat, setValidCodCat] = useState('')
  const [validEanDisplay, setValidEanDisplay] = useState('')

  // Listagem de Produtos Inválidos
  const [invalidProducts, setInvalidProducts] = useState<any[]>([])
  const [invalidLoading, setInvalidLoading] = useState(false)
  const [invalidPage, setInvalidPage] = useState(1)
  const [invalidTotalPages, setInvalidTotalPages] = useState(1)
  const [invalidTotal, setInvalidTotal] = useState(0)
  const [invalidSearch, setInvalidSearch] = useState('')
  const [invalidStatusFilter, setInvalidStatusFilter] = useState('Pendente')
  const [invalidDistFilter, setInvalidDistFilter] = useState('')

  // Form de Produto Inválido (Correção / Promoção)
  const [openInvalidForm, setOpenInvalidForm] = useState(false)
  const [correctingInvalidProduct, setCorrectingInvalidProduct] = useState<any | null>(null)
  const [invalidSku, setInvalidSku] = useState('')
  const [invalidDescricao, setInvalidDescricao] = useState('')
  const [invalidFamilia, setInvalidFamilia] = useState('')
  const [invalidCategoria, setInvalidCategoria] = useState('')
  const [invalidMarca, setInvalidMarca] = useState('')
  const [invalidEan13, setInvalidEan13] = useState('')
  const [invalidDun14, setInvalidDun14] = useState('')
  const [invalidStatus, setInvalidStatus] = useState('Cadastrado')
  const [existingProducts, setExistingProducts] = useState<any[]>([])
  const [selectedProductSku, setSelectedProductSku] = useState('')
  const [invalidCategoriaPex, setInvalidCategoriaPex] = useState('')
  const [invalidUnCx, setInvalidUnCx] = useState<number | ''>('')
  const [invalidCodCat, setInvalidCodCat] = useState('')
  const [invalidEanDisplay, setInvalidEanDisplay] = useState('')

  // Importação e Exportação em lote de Produtos Inválidos
  const [openExportWarningModal, setOpenExportWarningModal] = useState(false)
  const [openImportVisualizer, setOpenImportVisualizer] = useState(false)
  const [importChanges, setImportChanges] = useState<any[]>([])
  const [importSummary, setImportSummary] = useState<any>({ total: 0, valid: 0, errors: 0 })
  const [importProcessing, setImportProcessing] = useState(false)
  const fileInputRef = React.useRef<HTMLInputElement>(null)

  useEffect(() => {
    const init = async () => {
      try {
        const userRole = String(user?.role || '').toLowerCase()
        setIsAdmin(userRole === 'administrador' || userRole === 'suporte')
        setDistribuidores(await carregarDistribuidores())
      } catch (err) {
        console.error('Erro de inicialização:', err)
      }
    }
    init()
  }, [user])

  // Carregar produtos válidos quando a aba ou filtros mudarem
  useEffect(() => {
    if (activeTab === 'valid_products' && isAdmin) {
      fetchValidProducts()
    }
  }, [activeTab, validPage, validStatusFilter, isAdmin])

  // Carregar produtos inválidos quando a aba ou filtros mudarem
  useEffect(() => {
    if (activeTab === 'invalid_products' && isAdmin) {
      fetchInvalidProducts()
    }
  }, [activeTab, invalidPage, invalidStatusFilter, invalidDistFilter, isAdmin])

  const handleValidSearchSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    setValidPage(1)
    fetchValidProducts()
  }

  const handleInvalidSearchSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    setInvalidPage(1)
    fetchInvalidProducts()
  }

  // Requisições para Produtos Válidos
  const fetchValidProducts = async () => {
    setValidLoading(true)
    try {
      const { data } = await api.get('/int/produtos', {
        params: {
          page: validPage,
          limit: 15,
          q: validSearch,
          status: validStatusFilter || undefined,
        },
      })
      setValidProducts(data.data || [])
      setValidTotalPages(data.totalPages || 1)
      setValidTotal(data.total || 0)
    } catch (error) {
      console.error('Erro ao buscar produtos válidos:', error)
      toast.error('Erro ao carregar os produtos válidos.')
    } finally {
      setValidLoading(false)
    }
  }

  const handleSaveValidProduct = async () => {
    if (!validSku || !validDescricao) {
      toast.error('SKU e Descrição são campos obrigatórios.')
      return
    }

    const payload = {
      sku: validSku,
      descricao: validDescricao,
      familia: validFamilia || undefined,
      categoria: validCategoria || undefined,
      marca: validMarca || undefined,
      ean13: validEan13 || undefined,
      dun14: validDun14 || undefined,
      categoria_pex: validCategoriaPex || undefined,
      status: validStatus || 'Ativo',
      un_cx: validUnCx !== '' ? Number(validUnCx) : undefined,
      cod_cat: validCodCat || undefined,
      ean_display: validEanDisplay || undefined,
    }

    try {
      if (editingValidProduct) {
        await api.put(`/int/produtos/${editingValidProduct.id}`, payload)
        toast.success('Produto atualizado com sucesso!')
      } else {
        await api.post('/int/produtos', payload)
        toast.success('Produto cadastrado com sucesso!')
      }
      setOpenValidForm(false)
      setEditingValidProduct(null)
      resetValidProductForm()
      fetchValidProducts()
    } catch (error: any) {
      console.error('Erro ao salvar produto:', error)
      toast.error(error.response?.data?.message || 'Erro ao salvar produto.')
    }
  }

  const resetValidProductForm = () => {
    setValidSku('')
    setValidDescricao('')
    setValidFamilia('')
    setValidCategoria('')
    setValidMarca('')
    setValidEan13('')
    setValidDun14('')
    setValidCategoriaPex('')
    setValidStatus('Ativo')
    setValidUnCx('')
    setValidCodCat('')
    setValidEanDisplay('')
  }

  const openEditValidForm = (prod: any) => {
    setEditingValidProduct(prod)
    setValidSku(prod.sku || '')
    setValidDescricao(prod.descricao || '')
    setValidFamilia(prod.familia || '')
    setValidCategoria(prod.categoria || '')
    setValidMarca(prod.marca || '')
    setValidEan13(prod.ean13 || '')
    setValidDun14(prod.dun14 || '')
    setValidCategoriaPex(prod.categoria_pex || '')
    setValidStatus(prod.status || 'Ativo')
    setValidUnCx(prod.un_cx ?? '')
    setValidCodCat(prod.cod_cat || '')
    setValidEanDisplay(prod.ean_display || '')
    setOpenValidForm(true)
  }

  // Requisições para Produtos Inválidos
  const fetchInvalidProducts = async () => {
    setInvalidLoading(true)
    try {
      const { data } = await api.get('/produtos/invalidos', {
        params: {
          page: invalidPage,
          limit: 15,
          q: invalidSearch,
          status: invalidStatusFilter || undefined,
          distId: invalidDistFilter || undefined,
        },
      })
      setInvalidProducts(data.data || [])
      setInvalidTotalPages(data.totalPages || 1)
      setInvalidTotal(data.total || 0)
    } catch (error) {
      console.error('Erro ao buscar produtos inválidos:', error)
      toast.error('Erro ao carregar os produtos inválidos.')
    } finally {
      setInvalidLoading(false)
    }
  }

  const openCorrectInvalidForm = async (prod: any) => {
    setCorrectingInvalidProduct(prod)
    setInvalidEan13(prod.ean13 || prod.codigo_importado || '')
    setInvalidSku(prod.sku || '')
    setInvalidDescricao(prod.descricao || '')
    setInvalidFamilia(prod.familia || '')
    setInvalidCategoria(prod.categoria || '')
    setInvalidMarca(prod.marca || '')
    setInvalidDun14(prod.dun14 || '')
    setInvalidCategoriaPex(prod.categoria_pex || '')
    setInvalidUnCx(prod.un_cx ?? '')
    setInvalidCodCat(prod.cod_cat || '')
    setInvalidEanDisplay(prod.ean_display || '')
    setInvalidStatus('Cadastrado')
    setSelectedProductSku('')
    setOpenInvalidForm(true)

    try {
      const { data } = await api.get('/int/produtos', { params: { limit: 1000 } })
      setExistingProducts(data.data || [])
    } catch (err) {
      console.error('Erro ao buscar produtos existentes:', err)
    }
  }

  const handleSaveInvalidProduct = async () => {
    const statusToSend = invalidStatus === 'Atualizar' ? 'Cadastrado' : invalidStatus

    if (statusToSend === 'Cadastrado') {
      if (!invalidSku || !invalidDescricao) {
        toast.error('SKU e Descrição são obrigatórios para processar o produto.')
        return
      }
    }

    const payload = {
      sku: invalidSku || undefined,
      descricao: invalidDescricao || undefined,
      familia: invalidFamilia || undefined,
      categoria: invalidCategoria || undefined,
      marca: invalidMarca || undefined,
      ean13: invalidEan13 || undefined,
      dun14: invalidDun14 || undefined,
      categoria_pex: invalidCategoriaPex || undefined,
      un_cx: invalidUnCx !== '' ? Number(invalidUnCx) : undefined,
      cod_cat: invalidCodCat || undefined,
      ean_display: invalidEanDisplay || undefined,
      status: statusToSend,
    }

    try {
      await api.put(`/produtos/invalidos/${correctingInvalidProduct.id}`, payload)
      toast.success(
        statusToSend === 'Cadastrado'
          ? 'Produto inválido processado com sucesso!'
          : 'Status do produto inválido atualizado com sucesso!'
      )
      setOpenInvalidForm(false)
      setCorrectingInvalidProduct(null)
      
      // Ir para o respectivo filtro de status do banco para visualizar o produto tratado
      if (statusToSend === 'Cadastrado') {
        setInvalidStatusFilter('Cadastrado')
      } else if (statusToSend === 'Ignorado') {
        setInvalidStatusFilter('Ignorado')
      }
      
      fetchInvalidProducts()
    } catch (error: any) {
      console.error('Erro ao corrigir produto inválido:', error)
      toast.error(error.response?.data?.message || 'Erro ao processar alteração.')
    }
  }

  // Mostrar modal com instruções de exportação
  const handleExportPending = () => {
    setOpenExportWarningModal(true)
  }

  // Disparar o download de fato da API
  const triggerExportDownload = async () => {
    try {
      const response = await api.get('/produtos/invalidos/export', {
        params: {
          q: invalidSearch || undefined,
          status: 'Pendente',
          distId: invalidDistFilter || undefined,
        },
        responseType: 'blob',
      })

      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'produtos_invalidos_pendentes.csv')
      document.body.appendChild(link)
      link.click()
      link.remove()
      toast.success('Arquivo CSV de pendências exportado com sucesso!')
    } catch (error) {
      console.error('Erro ao exportar planilha:', error)
      toast.error('Erro ao gerar planilha de exportação.')
    }
  }

  // Importar planilha CSV, validar com o backend e abrir o preview
  const handleFileImport = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return

    const formData = new FormData()
    formData.append('file', file)

    setImportProcessing(true)
    try {
      const { data } = await api.post('/produtos/invalidos/import/validate', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      const actions = data.actions || []
      const summary = data.summary || { total: 0, valid: 0, errors: 0 }

      if (actions.length === 0) {
        toast.warning('Nenhuma ação de importação ou alteração foi identificada no arquivo.')
        setImportProcessing(false)
        return
      }

      setImportSummary(summary)
      setImportChanges(actions)
      setOpenImportVisualizer(true)
    } catch (err: any) {
      console.error('Erro ao validar planilha:', err)
      toast.error(err.response?.data?.message || 'Erro ao validar a planilha. Verifique a formatação do arquivo.')
    } finally {
      setImportProcessing(false)
    }
    e.target.value = '' // Reseta input
  }

  // Executar tratamento em lote confirmando com o backend
  const handleProcessImportChanges = async () => {
    // Filtra apenas as ações válidas (valid === true) para enviar à API
    const validActions = importChanges.filter((item: any) => item.valid)

    if (validActions.length === 0) {
      toast.error('Não existem ações válidas no lote para processar.')
      return
    }

    setImportProcessing(true)
    try {
      const { data } = await api.post('/produtos/invalidos/import/confirm', {
        actions: validActions.map((item: any) => ({
          id: item.id,
          sku: item.sku,
          descricao: item.descricao,
          status: item.status,
          valid: item.valid,
          familia: item.familia,
          categoria: item.categoria,
          marca: item.marca,
          dun14: item.dun14,
          un_cx: item.un_cx,
          cod_cat: item.cod_cat,
          ean_display: item.ean_display,
          categoria_pex: item.categoria_pex,
        })),
      })

      toast.success(data.message || 'Importação em massa concluída com sucesso!')
      setOpenImportVisualizer(false)
      setImportChanges([])
      setInvalidStatusFilter('Cadastrado') // Mostra o resultado final na aba de corrigidos
      fetchInvalidProducts()
    } catch (err: any) {
      console.error('Erro ao confirmar importação:', err)
      toast.error(err.response?.data?.message || 'Erro ao processar importação em lote.')
    } finally {
      setImportProcessing(false)
    }
  }

  if (!isAdmin) {
    return (
      <DatabaseContainer>
        <DatabaseHeader>
          <h2>Acesso Restrito</h2>
          <p>Esta tela é restrita para administradores do sistema.</p>
        </DatabaseHeader>
      </DatabaseContainer>
    )
  }

  return (
    <DatabaseContainer>
      <DatabaseHeader>
        <h2>Base de Dados</h2>
        <p>Gerenciamento de produtos válidos da base interna e fila de tratamento de itens inválidos</p>
      </DatabaseHeader>

      <TabBar>
        <TabItem $active={activeTab === 'valid_products'} onClick={() => setActiveTab('valid_products')}>
          Produtos Internos
        </TabItem>
        <TabItem $active={activeTab === 'invalid_products'} onClick={() => setActiveTab('invalid_products')}>
          Produtos Inválidos
        </TabItem>
      </TabBar>

      {/* ABA 1: PRODUTOS INTERNOS (VÁLIDOS) */}
      {activeTab === 'valid_products' && (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
          <FiltersRow>
            <form onSubmit={handleValidSearchSubmit} style={{ width: '100%', maxWidth: '320px' }}>
              <SearchBox>
                <FiSearch />
                <input
                  type="text"
                  placeholder="Buscar por descrição, SKU, EAN..."
                  value={validSearch}
                  onChange={(e) => setValidSearch(e.target.value)}
                />
              </SearchBox>
            </form>

            <FiltersGroup>
              <StyledSelect
                value={validStatusFilter}
                onChange={(e) => {
                  setValidStatusFilter(e.target.value)
                  setValidPage(1)
                }}
              >
                <option value="">Todos os Status</option>
                <option value="Ativo">Ativo</option>
                <option value="Inativo">Inativo</option>
              </StyledSelect>

              <button
                onClick={() => {
                  setValidPage(1)
                  fetchValidProducts()
                }}
                style={{
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '10px',
                  color: '#ffffff',
                  width: '38px',
                  height: '38px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                }}
                title="Atualizar lista"
              >
                <FiRefreshCw />
              </button>

              <button
                onClick={() => {
                  resetValidProductForm()
                  setEditingValidProduct(null)
                  setOpenValidForm(true)
                }}
                style={{
                  background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '10px',
                  padding: '0 16px',
                  height: '38px',
                  fontWeight: 600,
                  fontSize: '13px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  cursor: 'pointer',
                  fontFamily: 'Montserrat',
                }}
              >
                <FiPlus />
                <span>Novo Produto</span>
              </button>
            </FiltersGroup>
          </FiltersRow>

          <TableWrapper>
            <ModernTable>
              <thead>
                <tr>
                  <th>SKU</th>
                  <th>Descrição</th>
                  <th>EAN 13</th>
                  <th>DUN 14</th>
                  <th>Família</th>
                  <th>Marca</th>
                  <th>UN/CX</th>
                  <th>Status</th>
                  <th style={{ textAlign: 'center' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                 {validLoading ? (
                  Array.from({ length: 8 }).map((_, i) => (
                    <tr key={`sk-v-${i}`}>
                      <td colSpan={9} style={{ padding: '6px 12px' }}>
                        <SkeletonRow style={{ height: '36px', margin: 0 }} />
                      </td>
                    </tr>
                  ))
                ) : validProducts.length === 0 ? (
                  <tr>
                    <td colSpan={9} style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>
                      Nenhum produto cadastrado com os filtros ativos.
                    </td>
                  </tr>
                ) : (
                  validProducts.map((prod) => (
                    <tr key={prod.id}>
                      <td style={{ fontWeight: 600 }}>{prod.sku}</td>
                      <td title={prod.descricao}>{prod.descricao}</td>
                      <td>{prod.ean13 || '—'}</td>
                      <td>{prod.dun14 || '—'}</td>
                      <td>{prod.familia || '—'}</td>
                      <td>{prod.marca || '—'}</td>
                      <td>{prod.un_cx ?? '—'}</td>
                      <td>
                        <StatusBadge $type={prod.status}>{prod.status || 'Ativo'}</StatusBadge>
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <ActionButton onClick={() => openEditValidForm(prod)} title="Editar Produto">
                          <FiEdit2 size={16} />
                        </ActionButton>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </ModernTable>
          </TableWrapper>

          <Paginator>
            <div className="info">
              Exibindo página <strong>{validPage}</strong> de <strong>{validTotalPages}</strong> (Total: {validTotal} produtos)
            </div>
            <div className="controls">
              <PageButton disabled={validPage <= 1} onClick={() => setValidPage(p => p - 1)}>
                Anterior
              </PageButton>
              <PageButton disabled={validPage >= validTotalPages} onClick={() => setValidPage(p => p + 1)}>
                Próxima
              </PageButton>
            </div>
          </Paginator>
        </div>
      )}

      {/* ABA 2: PRODUTOS INVÁLIDOS */}
      {activeTab === 'invalid_products' && (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
          <FiltersRow>
            <form onSubmit={handleInvalidSearchSubmit} style={{ width: '100%', maxWidth: '320px' }}>
              <SearchBox>
                <FiSearch />
                <input
                  type="text"
                  placeholder="Buscar por código ou descrição..."
                  value={invalidSearch}
                  onChange={(e) => setInvalidSearch(e.target.value)}
                />
              </SearchBox>
            </form>

            <FiltersGroup>
              <StyledSelect
                value={invalidDistFilter}
                onChange={(e) => {
                  setInvalidDistFilter(e.target.value)
                  setInvalidPage(1)
                }}
              >
                <option value="">Todos os Distribuidores</option>
                {distribuidores.map((d) => (
                  <option key={d.id} value={d.id}>
                    {d.fantasy_name || d.name}
                  </option>
                ))}
              </StyledSelect>

              <StyledSelect
                value={invalidStatusFilter}
                onChange={(e) => {
                  setInvalidStatusFilter(e.target.value)
                  setInvalidPage(1)
                }}
              >
                <option value="Pendente">Pendente</option>
                <option value="Cadastrado">Cadastrado</option>
                <option value="Ignorado">Ignorado</option>
              </StyledSelect>

              <button
                onClick={() => {
                  setInvalidPage(1)
                  fetchInvalidProducts()
                }}
                style={{
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '10px',
                  color: '#ffffff',
                  width: '38px',
                  height: '38px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                }}
                title="Atualizar lista"
              >
                <FiRefreshCw />
              </button>

              <button
                onClick={handleExportPending}
                style={{
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '10px',
                  color: '#ffffff',
                  padding: '0 16px',
                  height: '38px',
                  fontWeight: 600,
                  fontSize: '13px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  cursor: 'pointer',
                  fontFamily: 'Montserrat',
                }}
                title="Exportar todos os pendentes para Excel"
              >
                <span>Exportar Planilha</span>
              </button>

              <button
                onClick={() => fileInputRef.current?.click()}
                style={{
                  background: 'linear-gradient(135deg, #10b981, #059669)',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '10px',
                  padding: '0 16px',
                  height: '38px',
                  fontWeight: 600,
                  fontSize: '13px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  cursor: 'pointer',
                  fontFamily: 'Montserrat',
                }}
                title="Importar planilha corrigida"
              >
                <span>Importar Planilha</span>
              </button>
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileImport}
                accept=".xlsx, .xls"
                style={{ display: 'none' }}
              />
            </FiltersGroup>
          </FiltersRow>

          <TableWrapper>
            <ModernTable>
              <thead>
                <tr>
                  <th>Cód. Importado</th>
                  <th>Distribuidor</th>
                  <th>Descrição Importada</th>
                  <th>Família</th>
                  <th>Categoria</th>
                  <th>DUN 14</th>
                  <th>Data Registro</th>
                  <th>Status</th>
                  <th style={{ textAlign: 'center' }}>Corrigir</th>
                </tr>
              </thead>
              <tbody>
                 {invalidLoading ? (
                  Array.from({ length: 8 }).map((_, i) => (
                    <tr key={`sk-inv-${i}`}>
                      <td colSpan={9} style={{ padding: '6px 12px' }}>
                        <SkeletonRow style={{ height: '36px', margin: 0 }} />
                      </td>
                    </tr>
                  ))
                ) : invalidProducts.length === 0 ? (
                  <tr>
                    <td colSpan={9} style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>
                      Nenhum produto inválido nesta categoria.
                    </td>
                  </tr>
                ) : (
                  invalidProducts.map((prod) => (
                    <tr key={prod.id}>
                      <td style={{ fontWeight: 600 }}>{prod.codigo_importado}</td>
                      <td>{prod.distribuidor || '—'}</td>
                      <td title={prod.descricao}>{prod.descricao || '—'}</td>
                      <td>{prod.familia || '—'}</td>
                      <td>{prod.categoria || '—'}</td>
                      <td>{prod.dun14 || '—'}</td>
                      <td>{formatDateTimePtBr(prod.created_at)}</td>
                      <td>
                        <StatusBadge $type={prod.status}>{prod.status || 'Pendente'}</StatusBadge>
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {prod.status === 'Pendente' ? (
                          <ActionButton
                            onClick={() => openCorrectInvalidForm(prod)}
                            title="Corrigir e Cadastrar"
                            style={{ color: '#22c55e' }}
                          >
                            <FiCheck size={18} />
                          </ActionButton>
                        ) : (
                          <ActionButton onClick={() => openCorrectInvalidForm(prod)} title="Visualizar/Editar">
                            <FiEdit2 size={16} />
                          </ActionButton>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </ModernTable>
          </TableWrapper>

          <Paginator>
            <div className="info">
              Exibindo página <strong>{invalidPage}</strong> de <strong>{invalidTotalPages}</strong> (Total: {invalidTotal} registros)
            </div>
            <div className="controls">
              <PageButton disabled={invalidPage <= 1} onClick={() => setInvalidPage(p => p - 1)}>
                Anterior
              </PageButton>
              <PageButton disabled={invalidPage >= invalidTotalPages} onClick={() => setInvalidPage(p => p + 1)}>
                Próxima
              </PageButton>
            </div>
          </Paginator>
        </div>
      )}

      {/* DRAWER LATERAL: ADICIONAR / EDITAR PRODUTO VÁLIDO */}
      {openValidForm && (
        <ModernModalBackdrop>
          <ModernVerticalModal>
            <div className="header">
              <h3>{editingValidProduct ? 'Editar Produto Base' : 'Novo Produto Base'}</h3>
              <button
                className="btn-close"
                onClick={() => {
                  setOpenValidForm(false)
                  setEditingValidProduct(null)
                }}
                type="button"
              >
                <IoCloseCircleSharp />
              </button>
            </div>

            <div className="body">
              <ModalFieldGroup>
                <ModalLabel>SKU (Código Interno) *</ModalLabel>
                <ModalInput
                  type="text"
                  value={validSku}
                  onChange={(e) => setValidSku(e.target.value)}
                  placeholder="Ex: 119280"
                />
              </ModalFieldGroup>

              <ModalFieldGroup>
                <ModalLabel>Descrição *</ModalLabel>
                <ModalInput
                  type="text"
                  value={validDescricao}
                  onChange={(e) => setValidDescricao(e.target.value)}
                  placeholder="Ex: PROD NOVO 100G"
                />
              </ModalFieldGroup>

              <ModalFieldGroup>
                <ModalLabel>EAN 13 (Código Barras)</ModalLabel>
                <ModalInput
                  type="text"
                  value={validEan13}
                  onChange={(e) => setValidEan13(e.target.value)}
                  placeholder="789..."
                />
              </ModalFieldGroup>

              <ModalFieldGroup>
                <ModalLabel>DUN 14 (Caixa master)</ModalLabel>
                <ModalInput
                  type="text"
                  value={validDun14}
                  onChange={(e) => setValidDun14(e.target.value)}
                  placeholder="1789..."
                />
              </ModalFieldGroup>

              <ModalFieldGroup>
                <ModalLabel>Família</ModalLabel>
                <ModalInput
                  type="text"
                  value={validFamilia}
                  onChange={(e) => setValidFamilia(e.target.value)}
                  placeholder="Ex: AZEITES"
                />
              </ModalFieldGroup>

              <ModalFieldGroup>
                <ModalLabel>Categoria</ModalLabel>
                <ModalInput
                  type="text"
                  value={validCategoria}
                  onChange={(e) => setValidCategoria(e.target.value)}
                  placeholder="Ex: MERCEARIA"
                />
              </ModalFieldGroup>

              <ModalFieldGroup>
                <ModalLabel>Marca</ModalLabel>
                <ModalInput
                  type="text"
                  value={validMarca}
                  onChange={(e) => setValidMarca(e.target.value)}
                  placeholder="Ex: MARCA EXEMPLO"
                />
              </ModalFieldGroup>

              <ModalFieldGroup>
                <ModalLabel>UN por Caixa</ModalLabel>
                <ModalInput
                  type="number"
                  value={validUnCx}
                  onChange={(e) => setValidUnCx(e.target.value !== '' ? Number(e.target.value) : '')}
                  placeholder="Ex: 12"
                />
              </ModalFieldGroup>

              <ModalFieldGroup>
                <ModalLabel>Cód. Categoria</ModalLabel>
                <ModalInput
                  type="text"
                  value={validCodCat}
                  onChange={(e) => setValidCodCat(e.target.value)}
                  placeholder="Ex: CAT_01"
                />
              </ModalFieldGroup>

              <ModalFieldGroup>
                <ModalLabel>EAN Display</ModalLabel>
                <ModalInput
                  type="text"
                  value={validEanDisplay}
                  onChange={(e) => setValidEanDisplay(e.target.value)}
                  placeholder="Código EAN display secundário"
                />
              </ModalFieldGroup>

              <ModalFieldGroup>
                <ModalLabel>Categoria PEX</ModalLabel>
                <ModalInput
                  type="text"
                  value={validCategoriaPex}
                  onChange={(e) => setValidCategoriaPex(e.target.value)}
                  placeholder="Ex: PEX"
                />
              </ModalFieldGroup>

              <ModalFieldGroup>
                <ModalLabel>Status</ModalLabel>
                <ModalSelect
                  value={validStatus}
                  onChange={(e) => setValidStatus(e.target.value)}
                >
                  <option value="Ativo">Ativo</option>
                  <option value="Inativo">Inativo</option>
                </ModalSelect>
              </ModalFieldGroup>

              <SubmitButton type="button" onClick={handleSaveValidProduct} disabled={validLoading}>
                {validLoading ? 'Gravando...' : 'Salvar Produto'}
              </SubmitButton>
            </div>
          </ModernVerticalModal>
        </ModernModalBackdrop>
      )}

      {/* DRAWER LATERAL: CORRIGIR / PROMOVER PRODUTO INVÁLIDO */}
      {openInvalidForm && correctingInvalidProduct && (
        <ModernModalBackdrop>
          <ModernVerticalModal>
            <div className="header">
              <h3>Tratamento de Item Inválido</h3>
              <button
                className="btn-close"
                onClick={() => {
                  setOpenInvalidForm(false)
                  setCorrectingInvalidProduct(null)
                }}
                type="button"
              >
                <IoCloseCircleSharp />
              </button>
            </div>

            <div className="body">
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', background: 'rgba(234, 179, 8, 0.08)', padding: '16px', borderRadius: '12px', border: '1px solid rgba(234, 179, 8, 0.15)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#facc15' }}>
                  <FiAlertTriangle size={18} />
                  <strong style={{ fontSize: '13px', textTransform: 'uppercase' }}>Código Pendente</strong>
                </div>
                <p style={{ fontSize: '12px', color: '#e2e8f0', margin: '4px 0 0 0' }}>
                  Este item foi enviado pelo distribuidor <strong>{correctingInvalidProduct.distribuidor}</strong> com o código identificador original:
                </p>
                <span style={{ fontSize: '15px', fontWeight: 700, fontFamily: 'monospace', color: '#ffffff', background: 'rgba(255,255,255,0.05)', padding: '4px 10px', borderRadius: '6px', alignSelf: 'flex-start', marginTop: '6px' }}>
                  {correctingInvalidProduct.codigo_importado}
                </span>
                {correctingInvalidProduct.descricao && (
                  <p style={{ fontSize: '12px', color: '#94a3b8', margin: '6px 0 0 0' }}>
                    Descrição importada: <em>"{correctingInvalidProduct.descricao}"</em>
                  </p>
                )}
              </div>

              <ModalFieldGroup>
                <ModalLabel>Ação / Status</ModalLabel>
                <ModalSelect
                  value={invalidStatus}
                  onChange={(e) => {
                    const val = e.target.value
                    setInvalidStatus(val)
                    if (val !== 'Atualizar') {
                      setSelectedProductSku('')
                    }
                  }}
                >
                  <option value="Cadastrado">Cadastrar (Novo Produto na Base)</option>
                  <option value="Atualizar">Atualizar (Vincular a Produto Existente)</option>
                  <option value="Ignorado">Ignorar (Manter na fila como Ignorado)</option>
                  <option value="Pendente">Manter Pendente</option>
                </ModalSelect>
              </ModalFieldGroup>

              {invalidStatus === 'Atualizar' && (() => {
                const reactSelectOptions = existingProducts.map((p) => ({
                  value: p.sku,
                  label: `${p.sku} - ${p.descricao}`,
                }))
                const selectedOption = reactSelectOptions.find((opt) => opt.value === selectedProductSku) || null

                return (
                  <ModalFieldGroup>
                    <ModalLabel>Selecionar Produto Interno para Vincular *</ModalLabel>
                    <Select
                      value={selectedOption}
                      options={reactSelectOptions}
                      onChange={(newValue: any) => {
                        const sku = newValue?.value || ''
                        setSelectedProductSku(sku)
                        
                        const prod = existingProducts.find((p) => p.sku === sku)
                        if (prod) {
                          setInvalidSku(prod.sku || '')
                          setInvalidDescricao(prod.descricao || '')
                          setInvalidFamilia(prod.familia || '')
                          setInvalidCategoria(prod.categoria || '')
                          setInvalidMarca(prod.marca || '')
                          setInvalidEan13(prod.ean13 || '')
                          setInvalidDun14(prod.dun14 || '')
                          setInvalidCategoriaPex(prod.categoria_pex || '')
                          setInvalidUnCx(prod.un_cx ?? '')
                          setInvalidCodCat(prod.cod_cat || '')
                          setInvalidEanDisplay(prod.ean_display || '')
                        }
                      }}
                      placeholder="Busque por SKU ou descrição..."
                      styles={customSelectStyles}
                      isClearable
                    />
                  </ModalFieldGroup>
                )
              })()}

              {(invalidStatus === 'Cadastrado' || invalidStatus === 'Atualizar') && (
                <>
                  <p className="form-section-title">
                    {invalidStatus === 'Atualizar' ? 'Atualizar e Vincular Produto' : 'Cadastrar Novo Produto'}
                  </p>

                  <ModalFieldGroup>
                    <ModalLabel>SKU (Código Interno) *</ModalLabel>
                    <ModalInput
                      type="text"
                      value={invalidSku}
                      onChange={(e) => setInvalidSku(e.target.value)}
                      placeholder="Ex: 119285"
                      disabled={invalidStatus === 'Atualizar'}
                      style={invalidStatus === 'Atualizar' ? { opacity: 0.6, cursor: 'not-allowed' } : {}}
                    />
                  </ModalFieldGroup>

                  <ModalFieldGroup>
                    <ModalLabel>Descrição *</ModalLabel>
                    <ModalInput
                      type="text"
                      value={invalidDescricao}
                      onChange={(e) => setInvalidDescricao(e.target.value)}
                      placeholder="Ex: PRODUTO AJUSTADO 100G"
                    />
                  </ModalFieldGroup>

                  <ModalFieldGroup>
                    <ModalLabel>EAN 13</ModalLabel>
                    <ModalInput
                      type="text"
                      value={invalidEan13}
                      onChange={(e) => setInvalidEan13(e.target.value)}
                      placeholder="Geralmente o código importado acima"
                    />
                  </ModalFieldGroup>

                  <ModalFieldGroup>
                    <ModalLabel>DUN 14</ModalLabel>
                    <ModalInput
                      type="text"
                      value={invalidDun14}
                      onChange={(e) => setInvalidDun14(e.target.value)}
                      placeholder="DUN da caixa coletiva"
                    />
                  </ModalFieldGroup>

                  <ModalFieldGroup>
                    <ModalLabel>Família</ModalLabel>
                    <ModalInput
                      type="text"
                      value={invalidFamilia}
                      onChange={(e) => setInvalidFamilia(e.target.value)}
                      placeholder="Ex: AZEITES"
                    />
                  </ModalFieldGroup>

                  <ModalFieldGroup>
                    <ModalLabel>Categoria</ModalLabel>
                    <ModalInput
                      type="text"
                      value={invalidCategoria}
                      onChange={(e) => setInvalidCategoria(e.target.value)}
                      placeholder="Ex: MERCEARIA"
                    />
                  </ModalFieldGroup>

                  <ModalFieldGroup>
                    <ModalLabel>Marca</ModalLabel>
                    <ModalInput
                      type="text"
                      value={invalidMarca}
                      onChange={(e) => setInvalidMarca(e.target.value)}
                      placeholder="Ex: MARCA A"
                    />
                  </ModalFieldGroup>

                  <ModalFieldGroup>
                    <ModalLabel>UN por Caixa</ModalLabel>
                    <ModalInput
                      type="number"
                      value={invalidUnCx}
                      onChange={(e) => setInvalidUnCx(e.target.value !== '' ? Number(e.target.value) : '')}
                      placeholder="Ex: 12"
                    />
                  </ModalFieldGroup>

                  <ModalFieldGroup>
                    <ModalLabel>Cód. Categoria</ModalLabel>
                    <ModalInput
                      type="text"
                      value={invalidCodCat}
                      onChange={(e) => setInvalidCodCat(e.target.value)}
                      placeholder="Ex: CAT_01"
                    />
                  </ModalFieldGroup>

                  <ModalFieldGroup>
                    <ModalLabel>EAN Display</ModalLabel>
                    <ModalInput
                      type="text"
                      value={invalidEanDisplay}
                      onChange={(e) => setInvalidEanDisplay(e.target.value)}
                      placeholder="Código EAN display"
                    />
                  </ModalFieldGroup>

                  <ModalFieldGroup>
                    <ModalLabel>Categoria PEX</ModalLabel>
                    <ModalInput
                      type="text"
                      value={invalidCategoriaPex}
                      onChange={(e) => setInvalidCategoriaPex(e.target.value)}
                      placeholder="Ex: PEX"
                    />
                  </ModalFieldGroup>
                </>
              )}

              <SubmitButton type="button" onClick={handleSaveInvalidProduct} disabled={invalidLoading}>
                {invalidLoading ? 'Processando...' : 'Aplicar Tratamento'}
              </SubmitButton>
            </div>
          </ModernVerticalModal>
        </ModernModalBackdrop>
      )}

      {/* MODAL VISUALIZADOR DE IMPORTAÇÃO EM LOTE */}
      {openImportVisualizer && (
        <Modal style={{ zIndex: 99999 }}>
          <div className="content" style={{ maxWidth: 950, width: '95%', background: '#001842', borderRadius: '24px', border: '1px solid rgba(255,255,255,0.1)', overflow: 'hidden', padding: 0 }}>
            <button
              className="logout"
              onClick={() => {
                setOpenImportVisualizer(false)
                setImportChanges([])
              }}
              style={{ color: '#ffffff' }}
            >
              X
            </button>
            <div className="header" style={{ background: '#00246b', color: '#ffffff', padding: '16px 24px', fontSize: '18px', fontWeight: 700, borderRadius: '24px 24px 0 0' }}>
              Confirmar Alterações de Importação
            </div>
            <div className="resume" style={{ padding: '24px', maxHeight: '60vh', overflowY: 'auto', color: '#ffffff', borderRadius: '0' }}>
              <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '12px', padding: '16px', marginBottom: '20px' }}>
                <p style={{ margin: 0, fontSize: '13px', color: '#94a3b8', fontWeight: 600 }}>Resumo de Alterações Identificadas pelo Validador:</p>
                <div style={{ display: 'flex', gap: '24px', marginTop: '10px' }}>
                  <div>
                    <span style={{ fontSize: '20px', fontWeight: 700, color: '#3b82f6' }}>{importSummary.total}</span>
                    <span style={{ fontSize: '13px', marginLeft: '6px', color: '#e2e8f0' }}>enviados</span>
                  </div>
                  <div>
                    <span style={{ fontSize: '20px', fontWeight: 700, color: '#4ade80' }}>{importSummary.valid}</span>
                    <span style={{ fontSize: '13px', marginLeft: '6px', color: '#e2e8f0' }}>válidos a processar</span>
                  </div>
                  <div>
                    <span style={{ fontSize: '20px', fontWeight: 700, color: '#f87171' }}>{importSummary.errors}</span>
                    <span style={{ fontSize: '13px', marginLeft: '6px', color: '#e2e8f0' }}>erros encontrados</span>
                  </div>
                </div>
              </div>

              <div style={{ overflowX: 'auto', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '12px' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', textAlign: 'left' }}>
                  <thead>
                    <tr style={{ background: 'rgba(255,255,255,0.05)', color: '#94a3b8' }}>
                      <th style={{ padding: '10px' }}>Fila ID</th>
                      <th style={{ padding: '10px' }}>Código Importado</th>
                      <th style={{ padding: '10px' }}>Distribuidor</th>
                      <th style={{ padding: '10px' }}>Descrição</th>
                      <th style={{ padding: '10px' }}>SKU Vínculo</th>
                      <th style={{ padding: '10px' }}>Ação Detectada</th>
                      <th style={{ padding: '10px' }}>Validação</th>
                    </tr>
                  </thead>
                  <tbody>
                    {importChanges.map((change, idx) => (
                      <tr key={idx} style={{ borderBottom: '1px solid rgba(255,255,255,0.04)', opacity: change.valid ? 1 : 0.6 }}>
                        <td style={{ padding: '10px', color: '#94a3b8' }}>{change.id}</td>
                        <td style={{ padding: '10px', fontFamily: 'monospace', fontWeight: 600 }}>{change.codigo_importado}</td>
                        <td style={{ padding: '10px' }}>{change.distribuidor || '—'}</td>
                        <td style={{ padding: '10px' }} title={change.descricao}>{change.descricao || '—'}</td>
                        <td style={{ padding: '10px', color: '#3b82f6', fontWeight: 600 }}>{change.sku || 'Novo cadastro'}</td>
                        <td style={{ padding: '10px' }}>
                          <span
                            style={{
                              padding: '2px 8px',
                              borderRadius: '6px',
                              fontSize: '10px',
                              fontWeight: 700,
                              textTransform: 'uppercase',
                              background: change.status === 'Cadastrado' ? 'rgba(34, 197, 94, 0.12)' : 'rgba(239, 68, 68, 0.12)',
                              color: change.status === 'Cadastrado' ? '#4ade80' : '#f87171',
                            }}
                          >
                            {change.status === 'Cadastrado' ? 'Cadastrar/Vincular' : 'Ignorar'}
                          </span>
                        </td>
                        <td style={{ padding: '10px' }}>
                          {change.valid ? (
                            <span style={{ color: '#4ade80', fontWeight: 700 }}>Válido</span>
                          ) : (
                            <span style={{ color: '#f87171', fontWeight: 700 }} title={change.error}>
                              {change.error || 'Erro'}
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div style={{ background: 'rgba(0, 0, 0, 0.2)', borderTop: '1px solid rgba(255,255,255,0.06)', padding: '16px 24px', display: 'flex', justifyContent: 'flex-end', gap: '12px', borderRadius: '0 0 24px 24px' }}>
              <button
                onClick={() => {
                  setOpenImportVisualizer(false)
                  setImportChanges([])
                }}
                style={{
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '10px',
                  color: '#ffffff',
                  padding: '0 20px',
                  height: '40px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  fontFamily: 'Montserrat',
                }}
                disabled={importProcessing}
              >
                Cancelar
              </button>
              <button
                onClick={handleProcessImportChanges}
                style={{
                  background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '10px',
                  padding: '0 24px',
                  height: '40px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  fontFamily: 'Montserrat',
                }}
                disabled={importProcessing || importSummary.valid === 0}
              >
                {importProcessing ? 'Processando...' : 'Confirmar e Processar'}
              </button>
            </div>
          </div>
        </Modal>
      )}

      {/* MODAL DE AVISO DE EXPORTAÇÃO */}
      {openExportWarningModal && (
        <Modal style={{ zIndex: 99999 }}>
          <div className="content" style={{ maxWidth: 550, width: '90%', background: '#001842', borderRadius: '24px', border: '1px solid rgba(255,255,255,0.1)', overflow: 'hidden', padding: 0 }}>
            <button
              className="logout"
              onClick={() => setOpenExportWarningModal(false)}
              style={{ color: '#ffffff' }}
            >
              X
            </button>
            <div className="header" style={{ background: '#00246b', color: '#ffffff', padding: '16px 24px', fontSize: '18px', fontWeight: 700, borderRadius: '24px 24px 0 0' }}>
              Instruções para Exportação
            </div>
            <div className="body" style={{ padding: '24px', color: '#ffffff', fontSize: '14px', lineHeight: '1.6' }}>
              <p style={{ margin: '0 0 16px 0', color: '#94a3b8' }}>
                Você está prestes a exportar a lista de produtos inválidos com status <strong>Pendente</strong>.
              </p>
              
              <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '12px', padding: '16px', marginBottom: '20px' }}>
                <strong style={{ display: 'block', marginBottom: '8px', color: '#3b82f6' }}>Como realizar a correção offline:</strong>
                <ol style={{ margin: 0, paddingLeft: '20px', color: '#e2e8f0' }}>
                  <li style={{ marginBottom: '8px' }}>
                    Abra a planilha CSV gerada no Excel ou editor de sua preferência.
                  </li>
                  <li style={{ marginBottom: '8px' }}>
                    Na coluna <strong>status</strong>, preencha com <strong>Cadastrado</strong> ou <strong>Ignorado</strong> para os itens que deseja tratar.
                  </li>
                  <li style={{ marginBottom: '8px' }}>
                    Na coluna <strong>sku</strong>, informe o SKU de produto válido se desejar apenas vincular a um produto existente (Ação Atualizar).
                  </li>
                  <li>
                    Salve o arquivo como <strong>CSV</strong> (UTF-8, delimitador ;) e faça o upload através do botão <strong>Importar Planilha</strong>.
                  </li>
                </ol>
              </div>

              <p style={{ margin: 0, color: '#facc15', fontSize: '13px', fontWeight: 600 }}>
                Nota: Apenas as linhas com status alterado serão processadas na importação.
              </p>
            </div>
            <div style={{ background: 'rgba(0, 0, 0, 0.2)', borderTop: '1px solid rgba(255,255,255,0.06)', padding: '16px 24px', display: 'flex', justifyContent: 'flex-end', gap: '12px', borderRadius: '0 0 24px 24px' }}>
              <button
                onClick={() => setOpenExportWarningModal(false)}
                style={{
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '10px',
                  color: '#ffffff',
                  padding: '0 20px',
                  height: '40px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  fontFamily: 'Montserrat',
                }}
              >
                Cancelar
              </button>
              <button
                onClick={() => {
                  setOpenExportWarningModal(false)
                  triggerExportDownload()
                }}
                style={{
                  background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '10px',
                  padding: '0 24px',
                  height: '40px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  fontFamily: 'Montserrat',
                }}
              >
                Baixar Planilha
              </button>
            </div>
          </div>
        </Modal>
      )}
    </DatabaseContainer>
  )
}
